// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"70a13509","703":"4f1d69e5","787":"61b62c3a"}[chunkId] + ".chunk.js";
};